import { apiDelete, apiGet, apiPost } from '@/infrastructure/api-client';
import type { TrashItem } from '@/domain/history/contracts';

export const listTrash = (): Promise<{ items: TrashItem[] }> => apiGet('/api/trash');
export const restoreTrashItem = (id: string): Promise<{ ok: true }> =>
  apiPost(`/api/trash/${encodeURIComponent(id)}/restore`);
export const permanentlyDeleteTrashItem = (id: string, name: string): Promise<{ ok: true }> =>
  apiDelete(`/api/trash/${encodeURIComponent(id)}`, { name });

